/* ZUCK 2026-07-03: PDP model measurements popover.
   Companion to snippets/model-photo-tag.liquid + assets/model-measures.css.

   Behavior:
   - The tag renders as <button data-model-measures-trigger> with an inert
     <span class="model-measures-source"> carrying the popover rows.
   - On open we CLONE that source into a single body-level popover element,
     positioned next to the trigger with getBoundingClientRect (flips up/down,
     clamped to the viewport) so the gallery's overflow:hidden can't clip it.
   - Event delegation on document (capture) so it works for the tag nodes Dawn
     reuses/adds when switching variant (updateMedia reuses <li> innerHTML).
   - One popover at a time; close on outside-click, Esc, and the x button;
     focus moves into the popover on open and back to the trigger on close. */
(function () {
  'use strict';
  if (window.__zuckModelMeasures) return;
  window.__zuckModelMeasures = true;

  var pop = null;
  var currentTrigger = null;
  var rafPending = false;
  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function ensurePopover() {
    if (pop) return pop;
    pop = document.createElement('div');
    pop.className = 'model-measures-popover';
    pop.id = 'ZuckModelMeasuresPopover';
    pop.setAttribute('role', 'dialog');
    pop.setAttribute('aria-modal', 'false');
    pop.setAttribute('tabindex', '-1');
    pop.hidden = true;
    document.body.appendChild(pop);
    return pop;
  }

  function focusables() {
    return pop.querySelectorAll(
      'button, [href], [tabindex]:not([tabindex="-1"])'
    );
  }

  function positionPopover() {
    if (!currentTrigger || !currentTrigger.isConnected) {
      close(false);
      return;
    }
    var r = currentTrigger.getBoundingClientRect();
    if (
      r.bottom < 0 ||
      r.top > window.innerHeight ||
      r.right < 0 ||
      r.left > window.innerWidth
    ) {
      close(false);
      return;
    }
    var pw = pop.offsetWidth;
    var ph = pop.offsetHeight;
    var vw = document.documentElement.clientWidth;
    var vh = window.innerHeight;
    var gap = 8;
    var margin = 8;

    var left = r.left + r.width / 2 - pw / 2;
    left = Math.max(margin, Math.min(left, vw - pw - margin));

    var placement = 'top';
    var top = r.top - ph - gap;
    if (top < margin) {
      var below = r.bottom + gap;
      if (below + ph <= vh - margin) {
        top = below;
        placement = 'bottom';
      } else {
        top = Math.max(margin, vh - ph - margin);
        placement = r.top > vh / 2 ? 'top' : 'bottom';
      }
    }
    pop.style.left = Math.round(left) + 'px';
    pop.style.top = Math.round(top) + 'px';
    pop.setAttribute('data-placement', placement);
  }

  function onScrollResize() {
    if (!currentTrigger || rafPending) return;
    rafPending = true;
    window.requestAnimationFrame(function () {
      rafPending = false;
      if (currentTrigger) positionPopover();
    });
  }

  function openFor(trigger) {
    ensurePopover();
    if (currentTrigger && currentTrigger !== trigger) {
      currentTrigger.setAttribute('aria-expanded', 'false');
    }
    currentTrigger = trigger;

    var source = trigger.querySelector('.model-measures-source');
    var name = trigger.getAttribute('data-model-name') || 'modelo';
    pop.innerHTML = source ? source.innerHTML : '';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'mm-close';
    closeBtn.setAttribute('aria-label', 'Fechar');
    closeBtn.innerHTML = '&#10005;';
    pop.appendChild(closeBtn);

    pop.setAttribute('aria-label', 'Medidas da ' + name);
    pop.hidden = false;
    pop.removeAttribute('data-open');
    trigger.setAttribute('aria-expanded', 'true');

    positionPopover();

    window.requestAnimationFrame(function () {
      if (currentTrigger === trigger) pop.setAttribute('data-open', 'true');
    });

    try {
      pop.focus({ preventScroll: true });
    } catch (e) {
      pop.focus();
    }

    window.addEventListener('scroll', onScrollResize, true);
    window.addEventListener('resize', onScrollResize);
  }

  function close(returnFocus) {
    if (!currentTrigger) return;
    var trigger = currentTrigger;
    currentTrigger = null;

    window.removeEventListener('scroll', onScrollResize, true);
    window.removeEventListener('resize', onScrollResize);

    if (pop) {
      pop.removeAttribute('data-open');
      var hide = function () {
        if (!currentTrigger) {
          pop.hidden = true;
          pop.innerHTML = '';
        }
      };
      if (reduceMotion) hide();
      else window.setTimeout(hide, 180);
    }

    trigger.setAttribute('aria-expanded', 'false');
    if (returnFocus && trigger.isConnected) {
      try {
        trigger.focus({ preventScroll: true });
      } catch (e) {
        trigger.focus();
      }
    }
  }

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      var trigger = t && t.closest ? t.closest('[data-model-measures-trigger]') : null;
      if (!trigger) return;
      e.preventDefault();
      e.stopPropagation();
      if (currentTrigger === trigger) close(true);
      else openFor(trigger);
    },
    true
  );

  document.addEventListener('click', function (e) {
    if (!currentTrigger) return;
    var t = e.target;
    if (t && t.closest && t.closest('.mm-close')) {
      close(true);
      return;
    }
    if (pop && pop.contains(t)) return;
    close(false);
  });

  document.addEventListener('keydown', function (e) {
    if (!currentTrigger) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      close(true);
      return;
    }
    if (e.key === 'Tab' && pop && !pop.hidden) {
      var f = focusables();
      if (!f.length) {
        e.preventDefault();
        pop.focus();
        return;
      }
      var first = f[0];
      var last = f[f.length - 1];
      var active = document.activeElement;
      if (e.shiftKey) {
        if (active === first || active === pop) {
          e.preventDefault();
          last.focus();
        }
      } else if (active === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });
})();
